import { StyleSheet } from 'react-native';
import { isValidObject, tokens, useBreakpoint } from '@airtel/air-design-system';
export var getPayCategoryCardWidgetStyles = props => {
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var cardDateInputProps = props.cardDateInputProps,
    cardCVVInputProps = props.cardCVVInputProps;
  var flex = {
    dateExpirationInput: 1,
    cvvInput: 1
  };
  if (isSmallScreen) {
    flex.dateExpirationInput = isValidObject(cardCVVInputProps) ? 0.65 : 1;
    flex.cvvInput = isValidObject(cardDateInputProps) ? 0.35 : 1;
  }
  return StyleSheet.create({
    maginVertical8: {
      marginVertical: tokens.spacing.SPACING_8
    },
    dateCVVInputGroup: {
      flexDirection: 'row'
    },
    dateInput: {
      flex: flex.dateExpirationInput
    },
    cvvInput: {
      flex: flex.cvvInput,
      marginLeft: tokens.spacing.SPACING_16
    }
  });
};